module.exports = __webpack_public_path__ + "static/media/paragliding.5b90a93a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/paragliding.svg
// module id = 232
// module chunks = 0